module.exports = __webpack_public_path__ + "static/img/activity_sdy_02-1.d617ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_02-1.jpg
// module id = vHrc
// module chunks = 0